import { Component } from '@angular/core';

@Component({
  selector: 'app-style-loading-spinners',
  templateUrl: './style-loading-spinners.component.html',
  standalone: false,
})
export class StyleLoadingSpinnersComponent {}
